import styled from 'styled-components';
import { CardDescription, CardTitle } from 'components';

export const NotesGrid = styled.div.attrs({ className: 'flex flex-col gap-4' })``;

export const StyledCardTitle = styled(CardTitle).attrs({
  className: 'text-sm font-medium',
})``;

export const StyledCardDescription = styled(CardDescription).attrs({
  className: 'text-xs',
})``;
